import {
  ClientProduct,
  ClientProductCalculation,
} from 'types/clientProductTypes';
import { createUniqueRuntimeNumber } from 'utils/uniqueRuntimeNumberUtils';

export const createClientProductCalculation = (): ClientProductCalculation => ({
  agmPercent: 0,
  agmAmount: 0,
  partnerPercent: 0,
  partnerAmount: 0,
  discountPercent: 0,
  discountAmount: 0,
  tariffAmount: 0,
});

export const createClientProduct = (): ClientProduct => ({
  id: 0,
  m8ProductType: 'ADDITIONAL_BOSS_LICENSE',
  calculation: createClientProductCalculation(),
  description: '',
  defaultPartnerComission: 0,
});

export const createClientProductCalculationMock = (): ClientProductCalculation => ({
  agmPercent: 20,
  agmAmount: 125,
  partnerPercent: 20,
  partnerAmount: 45,
  discountPercent: 60,
  discountAmount: 280,
  tariffAmount: 760,
});

export const createClientProductMock = (): ClientProduct => ({
  id: createUniqueRuntimeNumber(),
  m8ProductType: 'ADDITIONAL_BOSS_LICENSE',
  calculation: createClientProductCalculationMock(),
  defaultPartnerComission: 20,
  description: 'Лицензия на 1 год',
});
